import React from "react";
import { Col, Row } from "react-bootstrap";
import { TicketPortalIssue } from "../constant";
const CreateTicket = (props) => {
    return (React.createElement(React.Fragment, null, TicketPortalIssue === null || TicketPortalIssue === void 0 ? void 0 : TicketPortalIssue.map((item, i) => (React.createElement(Row, { className: "mx-mob-0 " },
        React.createElement(Col, { lg: 12, className: "DMSan_14_500 txt_blackOne1 p-4 brd-top", onClick: () => props.setTicketType(item) }, item.title))))));
};
export default CreateTicket;
